import { AlertTriangle, Droplets, Scale } from "lucide-react";

const RISKS = [
  { icon: Droplets, label: "Illiquidity Risk" },
  { icon: AlertTriangle, label: "Capital Loss Risk" },
  { icon: Scale, label: "Regulatory Valuation Notice" },
];

export const Footer = () => {
  return (
    <footer data-testid="disclaimer-disclosure-section" className="border-t border-[#6D28D9]/15 bg-[#F5F3FF]">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10">
        <div className="flex flex-wrap items-center gap-3">
          {RISKS.map((r) => (
            <span key={r.label} className="flex items-center gap-2 border border-rose-600/30 bg-rose-600/[0.06] px-4 py-2 font-mono2 text-[10px] uppercase tracking-[0.2em] text-rose-700">
              <r.icon className="h-3.5 w-3.5" /> {r.label}
            </span>
          ))}
        </div>

        <h3 className="font-display mt-10 text-xl font-semibold tracking-tight text-slate-900">
          Disclaimer & Risk Disclosure
        </h3>
        <div className="mt-6 grid max-w-5xl grid-cols-1 gap-5 text-xs leading-relaxed text-slate-500 md:grid-cols-2">
          <p>
            PRE-IPO EXPERT provides information and assistance related to unlisted and Pre-IPO securities. The information available on this website is intended for general informational and educational purposes only and should not be considered financial, investment, legal, or tax advice. All prices shown are indicative sample figures for illustration.
          </p>
          <p>
            Investments in unlisted and Pre-IPO securities involve significant risks, including but not limited to limited liquidity, price volatility, valuation uncertainty, potential loss of capital, and delays or uncertainty regarding future listing or exit opportunities. Past performance or market information does not guarantee future results.
          </p>
          <p>
            Investors are advised to conduct their own independent research and consult with qualified financial, legal, or tax professionals before making any investment decision. PRE-IPO EXPERT does not guarantee returns, profits, listing of any company, or the future performance of any security.
          </p>
          <p>
            All investment decisions are made solely at the investor's own discretion and responsibility. Where required by applicable laws and regulations, PRE-IPO EXPERT operates in accordance with the relevant regulatory requirements and disclosures. Any transaction involving securities should be undertaken only through legally permitted and appropriately authorized channels. By using this website, you acknowledge and accept the risks associated with investments in unlisted and Pre-IPO securities.
          </p>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-6 border-t border-slate-200 pt-8 sm:flex-row sm:items-center">
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="PRE-IPO EXPERT" className="h-8 w-8 rounded-full object-contain" />
            <span className="font-display text-sm font-semibold tracking-[0.18em] text-slate-800">
              PRE-IPO <span className="text-[#6D28D9]">EXPERT</span>
            </span>
          </div>
          <p className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-slate-400">
            © {new Date().getFullYear()} PRE-IPO EXPERT · Information & Assistance Platform
          </p>
        </div>
      </div>
    </footer>
  );
};
